
<style scoped lang="less">
    @import "./global.less";
</style>

<style scoped lang="less">
    @import "./scoped";
</style>

<template>
    <div id="main" data-global-dialog="" data-global-loading="">
        <!-- 通用loading -->
        <Modal :width="200"
               :value="loading.state == 1"
               :closable="false"
               :mask-closable="false"
               :footer-hide="true"
               class-name="global-loading"
               @on-visible-change="loadingStateChange">
            <template slot="header">
                <p>&nbsp;</p>
            </template>
            <div class="bd" data-flex="main:center cross:center">
                <!-- <img src="../../assets/images/loading-1.gif" data-flex-box="0"> -->
                <p class="tips" data-flex-box="0">{{loading.tips}}</p>
            </div>
        </Modal>
        <!-- 通用loading end -->

        <!-- 通用alert弹窗 -->
        <Modal :width="380"
               :title="alertDialog.title"
               :value="alertDialog.state == 1"
               :closable="false"
               :mask-closable="false"
               class-name="global-dialog global-alert-dialog"
               @on-visible-change="alertDialogStateChange">
            <div class="bd" data-flex="dir:top main:center">
                <p class="msg" data-flex-box="0" v-html="alertDialog.msg"></p>
            </div>
            <template slot="footer">
                <Button type="primary" @click="hideAlertDialog">{{alertDialog.btnText}}</Button>
            </template>
        </Modal>
        <!-- 通用alert弹窗end -->

        <!-- 通用confirm弹窗 -->
        <Modal :width="380"
               :title="confirmDialog.title"
               :value="confirmDialog.state == 1"
               :closable="false"
               :mask-closable="false"
               class-name="global-dialog global-confirm-dialog"
               @on-visible-change="confirmDialogStateChange">
            <div class="bd" data-flex="dir:top main:center">
                <p class="msg" data-flex-box="0" v-html="confirmDialog.msg"></p>
            </div>
            <template slot="footer">
                <Button type="primary" @click="confirmDialogBtnClick($event, 1)">{{confirmDialog.btn1Text}}</Button>&nbsp;&nbsp;<Button
                type="error" @click="confirmDialogBtnClick($event, 2)">{{confirmDialog.btn2Text}}
            </Button>
            </template>
        </Modal>
        <!-- 通用confirm弹窗end -->
    </div>
</template>

<script>
    import bus from '../../libs/bus'
    import customEvents from '../../config/custom_events'
    import CommonMixin from '../../mixins/common'

    export default {
        mixins: [CommonMixin],
        components: {},
        props: {},
        data() {
            return {
                loading: {
                    state: 0,
                    tips: '正在加载中...'
                },
                alertDialog: {
                    state: 0,
                    title: '提示信息',
                    msg: '',
                    btnText: '我知道了',
                    btnCallback: null
                },
                confirmDialog: {
                    state: 0,
                    title: '确认信息',
                    msg: '',
                    btn1Text: '确 定',
                    bnt2Text: '取 消',
                    isBtn1Click: false,
                    isBtn2Click: false,
                    btn1Callback: null,
                    btn2Callback: null
                }
            }
        },
        computed: {},
        methods: {
            loadingStateChange(visible) {
                if (!visible) {
                    return
                }

                this.loadingChangeZIndex(9999)
            },
            loadingChangeZIndex(n) {
                const el1 = document.getElementsByClassName('global-loading')[0].parentNode
                const el2 = el1.getElementsByClassName('ivu-modal-mask')[0]
                el2.style.zIndex = n
            },
            alertDialogStateChange(visible) {
                if (visible) {
                    this.dialogChangeZIndex(9998)
                    return
                }

                this.isFunction(this.alertDialog.btnCallback) && this.alertDialog.btnCallback()
            },
            hideAlertDialog() {
                this.alertDialog.state = 0
                document.getElementById('app').dataset.globalDialog = ''
            },
            confirmDialogBtnClick(evt, btnType) {
                this.confirmDialog.state = 0
                this.confirmDialog.isBtn1Click = btnType == 1
                this.confirmDialog.isBtn2Click = btnType == 2
                document.getElementById('app').dataset.globalDialog = ''
            },
            confirmDialogStateChange(visible) {
                if (visible) {
                    this.dialogChangeZIndex(9998)
                    return
                }

                if (this.confirmDialog.isBtn1Click && this.isFunction(this.confirmDialog.btn1Callback)) {
                    this.confirmDialog.btn1Callback()
                } else if (this.confirmDialog.isBtn2Click && this.isFunction(this.confirmDialog.btn2Callback)) {
                    this.confirmDialog.btn2Callback()
                }
            },
            dialogChangeZIndex(n) {
                const el1 = document.getElementsByClassName('global-dialog')[0].parentNode
                const el2 = el1.getElementsByClassName('ivu-modal-mask')[0]
                el2.style.zIndex = n
            }
        },
        watch: {},
        created() {
            bus.$on(customEvents['loading.show'], message => {
                const el = document.getElementById('app')
                const s1 = el.dataset.globalLoading

                if (!this.isEmpty(s1)) {
                    return
                }

                el.dataset.globalLoading = this.rndString(8, 2)

                this.loading.state = 1
                this.loading.tips = message.tips
            })

            bus.$on(customEvents['loading.hide'], () => {
                this.loading.state = 0
                document.getElementById('app').dataset.globalLoading = ''
            })

            bus.$on(customEvents['AlertDialog.show'], message => {
                const el = document.getElementById('app')
                const s1 = el.dataset.globalDialog

                if (!this.isEmpty(s1)) {
                    return
                }

                el.dataset.globalDialog = this.rndString(8, 2)
                this.alertDialog = Object.assign({state: 1}, message)
            })

            bus.$on(customEvents['ConfirmDialog.show'], message => {
                const el = document.getElementById('app')
                const s1 = el.dataset.globalDialog

                if (!this.isEmpty(s1)) {
                    return
                }

                el.dataset.globalDialog = this.rndString(8, 2)

                this.confirmDialog = Object.assign({
                    state: 1,
                    isBtn1Click: false,
                    isBtn2Click: false
                }, message)
            })
        },
        mounted() {
        },
        beforeDestroy() {
        },
        destroyed() {
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/app/main.vue